import React, { Component, Fragment } from 'react'
import { LanguageConsumer, Translate } from '../../../contexts/LanguageContext';
import { Loading, BreadCrumb, Card, UserAccounts, Validator, VRules, VConditions, ErrorMessage } from '../../../components';
import { Rules, PaymentConfirm, Currencies, TransferOptionUrl } from '../../../components/Payment';
import { TransferOptionService } from '../../../services/TransferOptionService';
import { Tooltip } from 'reactstrap';
import { FlashPayService } from '../../../services/FlashPay';
import PatternLock from '../../../components/PatternLock';
import { Config, GetUserToken } from "../../../helpers/Config";
import { Link } from 'react-router-dom';
import { DepositService } from '../../../services/DepositService';
import Select from 'react-select';
import { DataTableColumns } from '../../../helpers/DataTableColumns';
import DataTable from 'react-data-table-component';


export class FlashPayDeposit extends Component {

    constructor(props) {
        super(props)

        this.Refs = React.createRef();

        this.state = {
            loading: false,
            confirm: false,
            paymentOptions: {
                acceptedCurrencies: [],
                description: "",
                rules: [],
                title: ""
            },
            availableMargin: 0,
            // Payment Form
            login: 0,
            amount: 0,
            currency: "",
            validation: {
                error: false,
                message: ""
            },
            hasAccount: false,
            kointraAuthenticated: false,
            pattern: [],
            loginForm: {
                pattern_code: "",
                password: ""
            },
            userDetail: {
                token: "",
                userGuid: "",
                pendingDeposit: null
            },
            patternSelected: false,
            registerForm: {
                identityFront: null,
                identityFrontName: null,
                identityBack: null,
                identityBackName: null,
                residence: null,
                residenceName: null,
                selfie: null,
                selfieName: null,
                identityNumber: "",
                password: "",
                confirmPassword: "",
                pattern_code: ""
            },
            bankList: null,
            kointraDeposit: {
                amount: 0,
                bankId: 0,
            },
            cardMessage: null,
            showCard: false,
            kointraConfirm: false,
            kointraValidation: {
                error: false,
                message: ""
            }
        }

        this.onLoginChange = this.onLoginChange.bind(this);
        this.onLogin = this.onLogin.bind(this);
        this.onRegister = this.onRegister.bind(this);
        this.onCancelKointraDeposit = this.onCancelKointraDeposit.bind(this);
        this.bankAccounts = [];
        this.selectedBank = null;
    }
    // componentWillMount() {
    //     TransferOptionService.Deposit.OptionPage(TransferOptionUrl()).then(response => {

    //         if (!response) {
    //             document.location.href = "/deposit";
    //             return false;
    //         }

    //         this.setState({
    //             paymentOptions: response,
    //             currency: "TRY",
    //             error: false
    //         })
    //     });

    //     FlashPayService.HasAccountDeposit().then(response => {
    //         if (response && !response.error) {
    //             this.setState({
    //                 hasAccount: response.data.hasAccount,
    //                 loading: false,
    //             })
    //         }

    //     });
    // }
    changeAccount(userAccount) {
        this.setState({
            login: userAccount.active
        });
    }
    onChangeForm(e, key) {

        let value = e.target.value;

        if (key === "amount" && parseFloat(value) > this.state.availableMargin)
            value = this.state.availableMargin;

        this.setState({
            [key]: value
        });
    }

    onKointraChangeForm(value, key) {
        let kointraDepositForm = this.state.kointraDeposit;
        kointraDepositForm[key] = value;
        if (key === "bankId") {
            this.state.bankList.forEach((item) => { value.value === item.bankID ? this.selectedBank = item : this.selectedBank = this.selectedBank });
        }
        this.setState({
            kointraDeposit: kointraDepositForm
        });
    }

    onAvailableMargin() {

        this.setState({
            amount: this.state.availableMargin
        });
    }
    onToggleDeposit() {
        if (this.isValid())
            this.setState(prevState => ({
                confirm: !prevState.confirm
            }));
    }
    onToggleKointraDeposit() {
        if (this.isKointraDepositValid())
            this.setState(prevState => ({
                kointraConfirm: !prevState.kointraConfirm
            }));
    }
    isKointraDepositValid() {
        if (!this.state.kointraConfirm) {
            VRules["bankId"] = {
                Invalid: (value) => {
                    return VConditions.Required(value)
                },
                Message: Translate("Password can not be empty.")
            }
            let error = Validator.Valid({ amount: this.state.kointraDeposit.amount, bankID: this.state.kointraDeposit.bankId }, this.Refs);

            this.setState({
                kointraValidation: error
            });

            return !error.error;
        }

        return true;
    }

    isValid() {

        if (!this.state.confirm) {

            let error = Validator.Valid({ amount: this.state.amount }, this.Refs);

            this.setState({
                validation: error
            });

            return !error.error;
        }

        return true;

    }
    onConfirmDeposit() {
        this.setState({ loading: true }, () => {

            DepositService.FlashPay({
                login: this.state.login,
                amount: this.state.amount,
                currency: this.state.currency,
                token: this.state.userDetail.token,
                userGuid: this.state.userDetail.userGuid
            }).then((response) => {

                if (response.error) {
                    this.setState({
                        validation: {
                            error: response.error,
                            message: response.message
                        },
                        loading: false
                    });
                }
                else {
                    let userDetail = this.state.userDetail;
                    userDetail.token = null;
                    userDetail.userGuid = null;
                    this.setState({
                        loading: false,
                        success: !response.error,
                        showCard: true,
                        cardMessage: Translate("Your deposit request was completed successfully.")
                    });
                }

            });

        });
    }
    onLoginChange(key, value) {
        let loginForm = this.state.loginForm;
        loginForm[key] = value;
        this.setState({
            loginForm: loginForm
        });
    }

    onLogin(e) {
        e.preventDefault();

        if (this.isLoginValid(this.state.loginForm)) {
            this.setState({
                loading: true
            });
            FlashPayService.LoginDeposit(this.state.loginForm).then(res => {

                if (res) {
                    if (!res.error) {
                        this.setState({
                            userDetail: res.data,
                            kointraAuthenticated: true,
                            availableMargin: res.data.tryBalance,
                            bankList: res.bankList
                        });
                    }
                    else {
                        this.setState({
                            validation: {
                                error: res.error,
                                message: res.message
                            }
                        });
                    }
                    this.setState({ loading: false, bankList: res.bankList });
                    this.bankAccounts = res.bankList.map((item) => ({ value: item.bankID, label: <span>{item.bankName}</span> }));
                }
                else {
                    //error
                }
                this.setState({
                    loading: false
                });
            });
        }

    }

    isLoginValid(data) {

        VRules["password"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Password can not be empty.")
        }

        VRules["pattern_code"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Pattern can not be empty.")
        }


        let error = Validator.Valid(data, this.Refs);

        this.setState({
            validation: error,
        });

        return !error.error;
    }

    onRegisterChange(key, value) {
        let registerForm = this.state.registerForm;
        registerForm[key] = value;
        this.setState({
            registerForm: registerForm
        });
    }

    handleFileUpload(key, file) {
        let registerForm = this.state.registerForm;
        registerForm[key] = file.target.files[0];
        registerForm[key + "Name"] = file.target.files[0].name;
        this.setState({
            registerForm: registerForm
        })
    }

    onRegister(e) {

        e.preventDefault();
        const data = new FormData();
        const registerForm = this.state.registerForm;
        if (registerForm.password !== registerForm.confirmPassword) {
            this.setState({
                validation: {
                    error: true,
                    message: Translate("Password and confirm password was not matched.")
                }
            })
        }
        //TODO: password regex and pattern length 

        if (this.isRegisterValid(registerForm)) {

            Object.keys(registerForm).forEach(function (key) {
                data.append(key, registerForm[key]);
            })
            this.setState({
                loading: true
            })
            const xhr = new XMLHttpRequest();

            xhr.open("POST", Config.service.flashPay.deposit.register, true);

            xhr.setRequestHeader('Authorization', 'Bearer ' + GetUserToken());
            xhr.send(data);

            xhr.onload = () => {
                if (xhr.status === 200) {
                    let res = JSON.parse(xhr.response);
                    if (res && res.error) {
                        this.setState({
                            loading: false,
                            validation: {
                                error: true,
                                message: res.message
                            }
                        })
                    }
                    else {
                        this.setState({
                            cardMessage: res.message,
                            showCard: true,
                            loading: false
                        })
                    }
                }
            }
        }


    }

    isRegisterValid(data) {

        VRules["password"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Password can not be empty.")
        }
        VRules["confirmPassword"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Confirm Password can not be empty.")
        }
        VRules["identityFront"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Identity front file can not be empty.")
        }

        VRules["identityBack"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Identity back file can not be empty.")
        }
        VRules["residence"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Residence file can not be empty.")
        }
        VRules["selfie"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Selfie file can not be empty.")
        }
        VRules["pattern_code"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Pattern can not be empty.")
        }
        const validData = {
            password: data.password,
            confirmPassword: data.confirmPassword,
            identityFront: data.identityFront,
            identityBack: data.identityBack,
            residence: data.residence,
            selfie: data.selfie,
            pattern_code: data.pattern_code
        }

        let error = Validator.Valid(validData, this.Refs);

        this.setState({
            validation: error,
        });

        return !error.error;
    }
    onConfirmKointraDeposit() {
        this.setState({ loading: true }, () => {

            DepositService.FlashPayDepositToKointra({
                amount: this.state.kointraDeposit.amount,
                token: this.state.userDetail.token,
                userGuid: this.state.userDetail.userGuid,
                bankId: this.state.kointraDeposit.bankId.value
            }).then((response) => {

                if (response.error) {

                    this.setState({
                        kointraValidation: {
                            error: response.error,
                            message: response.message
                        },
                        kointraConfirm: false,
                        loading: false
                    });
                }
                else {


                    let cardContent = <React.Fragment>
                        <div className="row">
                            <div className="col-md-2">
                                {Translate("Reference Number")}:
                            </div>
                            <div className="col-md-5 text-dark">
                                {response.data}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-2">
                                {Translate("Bank Name")}:
                               </div>
                            <div className="col-md-5 text-dark">
                                {this.selectedBank.bankName}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-2">
                                {Translate("Account Name")}:
                           </div>
                            <div className="col-md-5 text-dark">
                                {this.selectedBank.accountName}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-2">
                                {Translate("Account Number")}:
                           </div>
                            <div className="col-md-5 text-dark">
                                {this.selectedBank.accountNumber}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-2">
                                {Translate("Branch")}:
                           </div>
                            <div className="col-md-5 text-dark">
                                {this.selectedBank.branch}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-2">
                                {Translate("IBAN")}:
                           </div>
                            <div className="col-md-5 text-dark">
                                {this.selectedBank.iban}
                            </div>
                        </div></React.Fragment>;

                    this.setState({
                        loading: false,
                        success: !response.error,
                        userDetail: {},
                        cardMessage: cardContent,
                        showCard: true
                    });
                }

            });

        });
    }

    onCancelKointraDeposit(e) {
        this.setState({
            loading: true
        });
        DepositService.FlashPayCancelDeposit({ userGuid: this.state.userDetail.userGuid, token: this.state.userDetail.token }).then(res => {

            let userDetail = this.state.userDetail;
            userDetail.pendingDeposit = null;
            if (res) {
                if (!res.error) {
                    this.setState({
                        userDetail: userDetail,
                        loading: false,
                        kointraValidation: {
                            error: false,
                            message: ""
                        },
                    });
                }
                else {
                    this.setState({
                        kointraValidation: res,
                        loading: false
                    });
                }
            }
            else {
                //error
            }
            this.setState({
                loading: false
            });
        });
    }
    render() {
        return (
            <LanguageConsumer>
                {() => (
                    <div className="tra-flashpay__page flashpay__deposit">
                        <div className="tra-flashpay__page flashpay__deposit">
                            <Loading Show={this.state.loading} Title={Translate("Loading Content")} />
                            <BreadCrumb Title={this.state.paymentOptions.title} Name={this.state.paymentOptions.title} SubTitle={Translate("Deposit")} SubUrl="/deposit" />
                            <div className="row">
                                <div className="col-12">
                                    <div className="tra-hasnt__account">
                                        <div className="card">
                                            <div className="bg-primary p-4 text-white text-center position-relative">
                                                <h4>
                                                    <ErrorMessage Validation={{ error: true, message: (Translate('We are currently unable to do this. Please contact your customer representative!')) }} />
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                )}
            </LanguageConsumer>
        )
        // return (
        //     <LanguageConsumer>
        //         {() => (
        //             <div className="tra-flashpay__page flashpay__deposit">
        //                 <Loading Show={this.state.loading} Title={Translate("Loading Content")} />
        //                 <BreadCrumb Title={this.state.paymentOptions.title} Name={this.state.paymentOptions.title} SubTitle={Translate("Deposit")} SubUrl="/deposit" />

        //                 {this.state.showCard ?
        //                     <div className="row">
        //                         <div className={"col-md-12 "}>
        //                             <Card Logo={this.state.paymentOptions.logo}>
        //                                 <div className={"alert alert-success alert-dismissible flashpay__deposit-info-alert fade mb-0 show"} role="alert">
        //                                     <strong>{Translate("Success")} &nbsp;</strong>
        //                                     {this.state.cardMessage}
        //                                 </div>
        //                                 <div className="mt-4">
        //                                     <Link className="btn btn-lg btn-info mb-3" to="/deposit"><i className="fas fa-chevron-left"></i>{Translate("&nbsp; Back to Deposit Page")}</Link>
        //                                 </div>
        //                             </Card>
        //                         </div>
        //                     </div>

        //                     :
        //                     this.state.loading && !this.state.hasAccount && !this.state.kointraAuthenticated ? "" :
        //                         this.state.hasAccount ?
        //                             //hesabı varsa
        //                             this.state.kointraAuthenticated ?
        //                                 //loginse
        //                                 <div className="row">
        //                                     <div className="col-md-6">
        //                                         <Card Title={this.state.paymentOptions.title} Description={this.state.paymentOptions.description} Logo={this.state.paymentOptions.logo}>
        //                                             <div className="row">
        //                                                 <div className="col-md-12">
        //                                                     <Rules Items={this.state.paymentOptions.rules} />
        //                                                 </div>
        //                                                 <div className="col-md-12">
        //                                                     <ErrorMessage Validation={this.state.validation} />
        //                                                 </div>
        //                                                 {!this.state.confirm ?
        //                                                     <Fragment>
        //                                                         <form className="form-horizontal send-to__tra col-md-12" name="depositForm" ref={this.Refs}>
        //                                                             <h4 className="mt-0 header-title m-b-20 mt-4 text-dark"><i className="fas fa-file-invoice"></i>{Translate("&nbsp; Send Money to <b>ARTSMRKTS</b> Account")}</h4>
        //                                                             <div className="form-group row ml-3">
        //                                                                 <label htmlFor="example-text-input" className="col-sm-4 col-form-label">{Translate(" Account")}</label>
        //                                                                 <div className="col-sm-8">
        //                                                                     <UserAccounts List className="bg-dark" Change={(e, userAccount) => this.changeAccount(userAccount)} Status="deposit" />
        //                                                                 </div>
        //                                                             </div>
        //                                                             <div className="form-group row ml-3">
        //                                                                 <label htmlFor="amount" className="col-sm-4 col-form-label">{Translate("Amount")}</label>
        //                                                                 <div className="col-sm-8">
        //                                                                     <div className="input-group">
        //                                                                         <input className="form-control" type="number" id="amount" value={this.state.amount} onChange={(e) => this.onChangeForm(e, "amount")} onFocus={e => e.target.select()} />
        //                                                                         <div className="input-group-append hide flashpay-deposit__input-group">
        //                                                                             <button type="button" className="input-group-text pt-0 pb-0 bg-white" id="availableMargin" onClick={(e) => this.onAvailableMargin()}>
        //                                                                                 <span>{Translate("Your Kointra Balance")}</span>
        //                                                                                 {this.state.availableMargin + " " + this.state.currency}
        //                                                                             </button>
        //                                                                             <Tooltip placement="right" isOpen={this.state.tooltipAvailableMargin} target="availableMargin" toggle={() => this.setState({ tooltipAvailableMargin: !this.state.tooltipAvailableMargin })}>
        //                                                                                 {Translate("Available Margin")}
        //                                                                             </Tooltip>
        //                                                                         </div>
        //                                                                     </div>
        //                                                                 </div>
        //                                                             </div>
        //                                                             <div className="form-group row ml-3">
        //                                                                 <label htmlFor="currency" className="col-sm-4 col-form-label">{Translate("Currency")}</label>
        //                                                                 <div className="col-sm-8">
        //                                                                     <Currencies Items={["TRY"]} onChange={(e) => this.onChangeForm(e, "currency")} />
        //                                                                 </div>
        //                                                             </div>
        //                                                             <div className="form-group row ml-3">
        //                                                                 <label htmlFor="example-text-input" className="col-sm-4 col-form-label"></label>
        //                                                                 <div className="col-sm-8">
        //                                                                     <button type="button" className="btn btn-lg btn-success" onClick={(e) => this.onToggleDeposit()}>{Translate("Create a Deposit Request")}</button>
        //                                                                 </div>
        //                                                             </div>
        //                                                         </form>


        //                                                     </Fragment>
        //                                                     :
        //                                                     <PaymentConfirm Deposit={true} Form={[
        //                                                         {
        //                                                             title: Translate("Account"),
        //                                                             value: this.state.login
        //                                                         },
        //                                                         {
        //                                                             title: Translate("Amount"),
        //                                                             value: this.state.amount.format('C') + " " + this.state.currency
        //                                                         }
        //                                                     ]} Cancel={(e) => this.onToggleDeposit()} Confirm={(e) => this.onConfirmDeposit()} />
        //                                                 }
        //                                             </div>
        //                                         </Card>
        //                                     </div>
        //                                     <div className="col-md-6">
        //                                         <Card Logo={this.state.paymentOptions.logo}>

        //                                             {this.state.userDetail.pendingDeposit === null
        //                                                 ?
        //                                                 !this.state.kointraConfirm
        //                                                     ?
        //                                                     <div className="row">
        //                                                         <div className="col-md-12">
        //                                                             <form className="form-horizontal send-to__kointra" name="depositForm">
        //                                                                 <h4 className="mt-0 header-title mt-3 text-dark"><i className="fas fa-file-invoice"></i>{Translate("&nbsp; Send Money to <b>KOINTRA</b> Account")}</h4>
        //                                                                 <div className="form-group row ml-3">
        //                                                                     <div className="col-sm-12">
        //                                                                         <div className="alert alert-warning" role="alert">
        //                                                                             {Translate("Please add a bank account and an amount, then write a reference number to the note.")}
        //                                                                         </div>
        //                                                                     </div>
        //                                                                 </div>
        //                                                                 <div className="form-group row ml-3">
        //                                                                     <ErrorMessage Validation={this.state.kointraValidation} />
        //                                                                 </div>
        //                                                                 <div className="form-group row ml-3">
        //                                                                     <label htmlFor="amount" className="col-sm-4 col-form-label">{Translate("Amount")}</label>
        //                                                                     <div className="col-sm-8">
        //                                                                         <input className="form-control" type="number" id="amount" onChange={(e) => this.onKointraChangeForm(e.target.value, "amount")} value={this.state.kointraDeposit.amount} onFocus={e => e.target.select()} />
        //                                                                     </div>
        //                                                                 </div>
        //                                                                 <div className="form-group row ml-3">
        //                                                                     <label htmlFor="currency" className="col-sm-4 col-form-label">{Translate("Currency")}</label>
        //                                                                     <div className="col-sm-8">
        //                                                                         <Currencies Items={["TRY"]} onChange={(e) => this.onChangeForm(e, "currency")} />
        //                                                                     </div>
        //                                                                 </div>
        //                                                                 <div className="form-group row ml-3">
        //                                                                     <label htmlFor="transfer-type" className="col-sm-4 col-form-label">{Translate("Bank Account")}</label>
        //                                                                     <div className="col-sm-8">
        //                                                                         <Select
        //                                                                             id="transfer-type"
        //                                                                             value={this.state.kointraDeposit.bankId}
        //                                                                             onChange={(e) => this.onKointraChangeForm(e, "bankId")}
        //                                                                             options={this.bankAccounts}
        //                                                                         />
        //                                                                     </div>
        //                                                                 </div>
        //                                                                 <div className="form-group row ml-3">
        //                                                                     <label htmlFor="example-text-input" className="col-sm-4 col-form-label"></label>
        //                                                                     <div className="col-sm-8">
        //                                                                         <button type="button" className="btn btn-lg btn-warning" onClick={(e) => this.onToggleKointraDeposit()}>{Translate("Create a Deposit Request")}</button>
        //                                                                     </div>
        //                                                                 </div>
        //                                                             </form>
        //                                                         </div>

        //                                                     </div>
        //                                                     :
        //                                                     <PaymentConfirm Deposit={true} Form={[
        //                                                         {
        //                                                             title: Translate("Account"),
        //                                                             value: this.state.login
        //                                                         },
        //                                                         {
        //                                                             title: Translate("Amount"),
        //                                                             value: this.state.kointraDeposit.amount.format('C') + " " + this.state.currency
        //                                                         },
        //                                                         {
        //                                                             title: Translate("Bank Account"),
        //                                                             value: this.selectedBank.bankName
        //                                                         }
        //                                                     ]} Cancel={(e) => this.onToggleKointraDeposit()} Confirm={(e) => this.onConfirmKointraDeposit()} />


        //                                                 :
        //                                                 <div className="row mt-5">
        //                                                     <div className="col-md-12">
        //                                                         <ErrorMessage Validation={this.state.kointraValidation} />
        //                                                     </div>
        //                                                     <div className="col-md-12">
        //                                                         <DataTable
        //                                                             noHeader={true}
        //                                                             columns={DataTableColumns.kointraDeposit(this.onCancelKointraDeposit)}
        //                                                             data={[this.state.userDetail.pendingDeposit]}
        //                                                             defaultSortField="date"
        //                                                             defaultSortAsc={false}
        //                                                             pagination
        //                                                             highlightOnHover />
        //                                                     </div>
        //                                                 </div>
        //                                             }


        //                                         </Card>

        //                                     </div>
        //                                 </div>
        //                                 :
        //                                 //login değilse
        //                                 <div className="wrapper-page tra-has__account">
        //                                     <div className="card overflow-hidden account-card mx-3">
        //                                         <div className="bg-primary p-4 text-white text-center position-relative">
        //                                             <h4 className="font-20 m-b-5">{Translate("Sign in to Kointra account for Deposit!")}</h4>
        //                                             <p className="text-white-50 mb-4">{Translate("Sign in to your Kointra account to continue")}</p>
        //                                             <div className="logo logo-admin">
        //                                                 <img src="/assets/psp-logo/kointra-icon.svg" height="64" alt="logo" />
        //                                             </div>
        //                                         </div>
        //                                         <div className="row">
        //                                             <div className="col-md-6 tra-login__wrapper">
        //                                                 <div className="account-card-content">
        //                                                     <form className="form-horizontal m-t-30">
        //                                                         <div className="form-group mt-5">
        //                                                             <ErrorMessage Validation={this.state.validation} />
        //                                                         </div>
        //                                                         <div className="form-group">
        //                                                             <label htmlFor="userpassword">{Translate("Password")}</label>
        //                                                             <input type="password" autoComplete="new-password" className="form-control" value={this.state.loginForm.password} id="userpassword" onChange={(e) => this.onLoginChange("password", e.target.value)} placeholder="Enter password" />
        //                                                         </div>
        //                                                         <div className="form-group">
        //                                                             <label htmlFor="pattern">{Translate("Pattern")}</label>
        //                                                             <div className="row">
        //                                                                 <div className="text-center pattern-parent">
        //                                                                     <PatternLock
        //                                                                         svgWidth={300}
        //                                                                         svgHeight={300}
        //                                                                         colums={4}
        //                                                                         rows={3}
        //                                                                         pattern={this.state.pattern}
        //                                                                         onCircleSelected={(code) => {
        //                                                                             let pattern = this.state.pattern;
        //                                                                             if (this.state.patternSelected) {
        //                                                                                 pattern = [];
        //                                                                             }
        //                                                                             pattern.push(code);
        //                                                                             code = code + 1;
        //                                                                             this.setState({
        //                                                                                 patternSelected: false,
        //                                                                                 pattern: pattern
        //                                                                             })
        //                                                                         }}
        //                                                                         onPatternSelected={() => {

        //                                                                             let pattern_code = "";
        //                                                                             this.state.pattern.forEach((v) => {
        //                                                                                 pattern_code += parseInt(v) + 1;
        //                                                                             });
        //                                                                             this.onLoginChange("pattern_code", pattern_code);
        //                                                                             this.setState({ patternSelected: true });
        //                                                                         }}
        //                                                                     />
        //                                                                 </div>
        //                                                             </div>
        //                                                         </div>
        //                                                         <div className="form-group row m-t-20">
        //                                                             <div className="col-sm-12 text-center">
        //                                                                 <button type="button" onClick={(e) => this.onLogin(e)} className="btn btn-warning w-md waves-effect waves-light">{Translate("Log In")}</button>
        //                                                             </div>
        //                                                         </div>
        //                                                     </form>
        //                                                 </div>

        //                                             </div>
        //                                             <div className="col-md-6 tra-login__desc">
        //                                                 <Rules Items={this.state.paymentOptions.rules} />
        //                                             </div>

        //                                         </div>
        //                                     </div>
        //                                 </div>
        //                             :
        //                             //register
        //                             <div className="row">
        //                                 <div className="col-12">
        //                                     <div className="tra-hasnt__account">
        //                                         <div className="card">
        //                                             <div className="bg-primary p-4 text-white text-center position-relative">
        //                                                 <h4 className="font-20 m-b-5">{Translate("Register in to Kointra for Withdrawal!")}</h4>
        //                                                 <p className="text-white-50 mb-4">{Translate("Register to your Kointra to continue")}</p>
        //                                                 <div className="logo logo-admin">
        //                                                     <img src="/assets/psp-logo/kointra-icon.svg" height="64" alt="logo" />
        //                                                 </div>
        //                                             </div>
        //                                             <div className="card-body">
        //                                                 <div className="alert alert-default mb-0" role="alert"><h4 className="alert-heading font-18">{Translate("Welcome to Flash Pay,")}</h4>
        //                                                     <p>{Translate("In this payment system, you can open an account quickly via our solution partner Kointra ‘Crypto Currency Exchange’ .")}</p>
        //                                                     <p className="mb-0">{Translate("By using Kointra as a bank account, you can fund your account in TL as fast as possible.")}</p>
        //                                                 </div>
        //                                                 <div className="alert alert-warning mb-5" role="alert">
        //                                                     <p className="mb-0">{Translate("Warning : All photos must be visible and updated.")}</p>
        //                                                 </div>
        //                                                 <div className="form-group row">
        //                                                     <ErrorMessage Validation={this.state.validation} />
        //                                                 </div>
        //                                                 <div className="form-group row">
        //                                                     <label htmlFor="example-text-input" className="col-sm-2 col-form-label">{Translate("Identity Card Front")}</label>
        //                                                     <div className="col-sm-4">
        //                                                         <div className="input-group">
        //                                                             <div className="custom-file">
        //                                                                 <input type="file" className="custom-file-input" id="identityFront" name="identityFront" aria-describedby="inputGroupFileAddon01" onChange={(e) => this.handleFileUpload("identityFront", e)} />
        //                                                                 <label className="custom-file-label" htmlFor="inputGroupFile01">{this.state.registerForm.identityFrontName ? this.state.registerForm.identityFrontName : Translate("Choose File")}</label>
        //                                                             </div>
        //                                                         </div>
        //                                                     </div>
        //                                                     <div className="col-sm-6">
        //                                                         <p className="text-muted tra-form__decription m-b-30"><i className="ion ion-ios-information-circle-outline"></i>{Translate("If you use your national identity card, then you must upload the front side here. Only JPG files are supported.")}</p>
        //                                                     </div>
        //                                                 </div>
        //                                                 <div className="form-group row">
        //                                                     <label htmlFor="example-text-input" className="col-sm-2 col-form-label">{Translate("Identity Card Back")}</label>
        //                                                     <div className="col-sm-4">
        //                                                         <div className="input-group">
        //                                                             <div className="custom-file">
        //                                                                 <input type="file" className="custom-file-input" id="identityBack" name="identityBack" aria-describedby="inputGroupFileAddon01" onChange={(e) => this.handleFileUpload("identityBack", e)} />
        //                                                                 <label className="custom-file-label" htmlFor="inputGroupFile01">{this.state.registerForm.identityBackName ? this.state.registerForm.identityBackName : Translate("Choose File")}</label>
        //                                                             </div>
        //                                                         </div>
        //                                                     </div>
        //                                                     <div className="col-sm-6">
        //                                                         <p className="text-muted tra-form__decription m-b-30"><i className="ion ion-ios-information-circle-outline"></i>{Translate("If you use your national identity card, then you must back side here. Only JPG files are supported.")}</p>
        //                                                     </div>
        //                                                 </div>
        //                                                 <div className="form-group row">
        //                                                     <label htmlFor="example-text-input" className="col-sm-2 col-form-label">{Translate("Residence")}</label>
        //                                                     <div className="col-sm-4">
        //                                                         <div className="input-group">
        //                                                             <div className="custom-file">
        //                                                                 <input type="file" className="custom-file-input" id="residence" name="residence" aria-describedby="inputGroupFileAddon01" onChange={(e) => this.handleFileUpload("residence", e)} />
        //                                                                 <label className="custom-file-label" htmlFor="inputGroupFile01">{this.state.registerForm.residenceName ? this.state.registerForm.residenceName : Translate("Choose File")}</label>
        //                                                             </div>
        //                                                         </div>
        //                                                     </div>
        //                                                     <div className="col-sm-6">
        //                                                         <p className="text-muted tra-form__decription m-b-30"><i className="ion ion-ios-information-circle-outline"></i>{Translate("Proof of residences upload as a pdf or jpg.")}</p>
        //                                                     </div>
        //                                                 </div>
        //                                                 <div className="form-group row">
        //                                                     <label htmlFor="selfie" className="col-sm-2 col-form-label">{Translate("Selfie")}</label>
        //                                                     <div className="col-sm-4">
        //                                                         <div className="input-group">
        //                                                             <div className="custom-file">
        //                                                                 <input type="file" className="custom-file-input" id="selfie" name="selfie" aria-describedby="inputGroupFileAddon01" onChange={(e) => this.handleFileUpload("selfie", e)} />
        //                                                                 <label className="custom-file-label" htmlFor="inputGroupFile01">{this.state.registerForm.selfieName ? this.state.registerForm.selfieName : Translate("Choose File")}</label>
        //                                                             </div>
        //                                                         </div>
        //                                                     </div>
        //                                                     <div className="col-sm-6">
        //                                                         <p className="text-muted tra-form__decription m-b-30"><i className="ion ion-ios-information-circle-outline"></i>{Translate("You should write ‘Kointra and Date’ on a blank paper, take the selfie via your hand and register to the system.")}</p>
        //                                                     </div>
        //                                                 </div>
        //                                                 <div className="form-group row">
        //                                                     <label htmlFor="identityNumber" className="col-sm-2 col-form-label">{Translate("Identity Number")}</label>
        //                                                     <div className="col-sm-4">
        //                                                         <input className="form-control" type="number" id="identityNumber" name="identityNumber" value={this.state.registerForm.identityNumber} onChange={(e) => this.onRegisterChange("identityNumber", e.target.value)} />
        //                                                     </div>
        //                                                     <div className="col-sm-6">
        //                                                         <p className="text-muted tra-form__decription m-b-30"><i className="ion ion-ios-information-circle-outline"></i>{Translate("Please enter ID Number")}</p>
        //                                                     </div>
        //                                                 </div>
        //                                                 <div className="form-group row">
        //                                                     <label htmlFor="ppsw" className="col-sm-2 col-form-label">{Translate("Password")}</label>
        //                                                     <div className="col-sm-4">
        //                                                         <input className="form-control" type="password" id="password" name="ppsw" value={this.state.registerForm.password} onChange={(e) => this.onRegisterChange("password", e.target.value)} />
        //                                                     </div>
        //                                                     <div className="col-sm-6">
        //                                                         <p className="text-muted tra-form__decription m-b-30"><i className="ion ion-ios-information-circle-outline"></i>{Translate("Password  must contain at least one lowercase letter, one uppercase letter and one special character.")}</p>
        //                                                     </div>
        //                                                 </div>
        //                                                 <div className="form-group row">
        //                                                     <label htmlFor="confirmPassword" className="col-sm-2 col-form-label">{Translate("Confirm Password")}</label>
        //                                                     <div className="col-sm-4">
        //                                                         <input className="form-control" type="password" value={this.state.registerForm.confirmPassword} id="confirmPassword" name="confirmPassword" onChange={(e) => this.onRegisterChange("confirmPassword", e.target.value)} />
        //                                                     </div>
        //                                                     <div className="col-sm-6">
        //                                                         <p className="text-muted tra-form__decription m-b-30"><i className="ion ion-ios-information-circle-outline"></i>{Translate("Please verify your password.")}</p>
        //                                                     </div>
        //                                                 </div>
        //                                                 <div className="form-group row">
        //                                                     <label htmlFor="example-datetime-local-input" className="col-sm-2 col-form-label">{Translate("Pattern")}</label>
        //                                                     <div className="col-md-4">
        //                                                         <div className="row p-4">
        //                                                             <div className="col-md-10 pattern-parent">
        //                                                                 <PatternLock
        //                                                                     svgWidth={300}
        //                                                                     svgHeight={300}
        //                                                                     colums={4}
        //                                                                     rows={3}
        //                                                                     pattern={this.state.pattern}
        //                                                                     onCircleSelected={(code) => {
        //                                                                         let pattern = this.state.pattern;
        //                                                                         if (this.state.patternSelected) {
        //                                                                             pattern = [];
        //                                                                         }
        //                                                                         pattern.push(code);
        //                                                                         code = code + 1;
        //                                                                         this.setState({
        //                                                                             patternSelected: false,
        //                                                                             pattern: pattern
        //                                                                         })
        //                                                                     }}
        //                                                                     onPatternSelected={() => {

        //                                                                         let pattern_code = "";
        //                                                                         this.state.pattern.forEach((v) => {
        //                                                                             pattern_code += parseInt(v) + 1;
        //                                                                         });
        //                                                                         this.onRegisterChange("pattern_code", pattern_code);
        //                                                                         this.setState({ patternSelected: true });
        //                                                                     }}
        //                                                                 />
        //                                                             </div>
        //                                                         </div>
        //                                                     </div>

        //                                                     <div className="col-sm-6">
        //                                                         <p className="text-muted tra-form__decription m-b-30"><i className="ion ion-ios-information-circle-outline"></i>{Translate("Please create a pattern.")}</p>
        //                                                     </div>
        //                                                 </div>
        //                                                 <div className="form-group row mb-0">
        //                                                     <div className="col-md-6 text-right">
        //                                                         <button type="button" className="btn btn-warning waves-effect waves-light bold btn-lg" onClick={(e) => this.onRegister(e)}>{Translate("Register")}</button>
        //                                                     </div>
        //                                                 </div>
        //                                             </div>
        //                                         </div>
        //                                     </div>
        //                                 </div>
        //                             </div>

        //                 }
        //             </div>
        //         )}
        //     </LanguageConsumer>
        // )
    }
}